import React from 'react'
import ReactDOM from 'react-dom'

import {
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Divider,
  Paper,
} from '@material-ui/core'
import { InfoOutlined as InfoOutlinedIcon } from '@material-ui/icons'

import ButtonLink from 'components/ButtonLink'

import useDaiChat from 'hooks/useDaiChat'

import useStyles from './styles'

const NewChatConfirmDialog = ({
  open = false,
  setOpen = () => {},
  onConfirm = () => {},
}) => {
  const classes = useStyles()
  const { chatContainerRef } = useDaiChat()

  const handleClose = () => setOpen(false)

  const handleConfirm = () => {
    onConfirm()
  }

  if (!open || !chatContainerRef.current) return null

  return ReactDOM.createPortal(
    <Box className={classes.overlay}>
      <Box className={classes.backdrop} onClick={handleClose} />
      <Box className={classes.paperContainer}>
        <Paper className={classes.dialog}>
          <DialogContent className={classes.content}>
            <InfoOutlinedIcon className={classes.icon} />
            <Box>
              <Typography className={classes.title}>
                Iniciar nova conversa?
              </Typography>
              <Typography className={classes.subtitle}>
                O histórico desta conversa será perdido.
              </Typography>
            </Box>
          </DialogContent>

          <Divider />

          <DialogActions className={classes.actions} disableSpacing>
            <ButtonLink onClick={handleClose}>
              Continuar nessa conversa
            </ButtonLink>
            <Button variant="contained" color="primary" onClick={handleConfirm}>
              Iniciar
            </Button>
          </DialogActions>
        </Paper>
      </Box>
    </Box>,
    chatContainerRef.current,
  )
}

export default NewChatConfirmDialog
